import {isUndefinedOrNullOrEmpty} from 'common/utils/isUndefinedOrNullOrEmpty';
import {Request} from 'common/domain/models/request';

class TeamRequestCardHelper {
  constructor() {
  }

  isHourly(request) {
    return request.hours !== undefined &&
           request.hours !== null &&
           request.hours > 0;
  }

  hasObservations(request) {
    return !isUndefinedOrNullOrEmpty(request.remarks);
  }

  isRejectAccept(request) {
    return request.status === Request.STATUS_REQUESTED.APPROVE ||
           request.status === Request.STATUS_REQUESTED.DELETE;
  }

  isDiscard(request) {
    return request.status === Request.STATUS_REQUESTED.DISCARD;
  }

  showActionTag(request) {
    return request.status !== Request.STATUS_REQUESTED.APPROVE;
  }
}

export default TeamRequestCardHelper;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCard.helper.js